import moment from 'moment';
import React from 'react';
import { DATE_ONLY_FORMAT, dateString } from 'researcher/helpers/date';
import { T, useTranslate } from 'shared/helper/translate';
import DigitalEditingSurvey from './DigitalEditingSurvey';
var DigitalEditingSidebar = function DigitalEditingSidebar(_ref) {
  var digitalEditEnabled = _ref.digitalEditEnabled,
    digitalEditingPurchase = _ref.digitalEditingPurchase,
    accessType = _ref.accessType,
    digitalEditingSurveyUrl = _ref.digitalEditingSurveyUrl,
    uuid = _ref.uuid;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "About Digital Editing"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-editing-overview"
  }), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "digital-editing-for-microsoft-word"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ms-2 badge bg-success rounded text-white text-small align-middle"
  }, /*#__PURE__*/React.createElement(T, {
    source: "word-addin-badge-release"
  }))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T.md, {
    source: "word-addin-overview"
  })), /*#__PURE__*/React.createElement("a", {
    className: "button btn btn-outline-primary w-100 text-wrap",
    href: "https://appsource.microsoft.com/en-us/product/office/WA200005612",
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "word-addin-download-cta"
  })), digitalEditEnabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "your-access-header-".concat(accessType)
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "your-access-overview-".concat(accessType),
    params: {
      subscriptionEndsDate: digitalEditingPurchase ? dateString(t, moment(digitalEditingPurchase.endsAt), DATE_ONLY_FORMAT) : ''
    }
  }), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Feedback"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-editing-feedback"
  }), /*#__PURE__*/React.createElement(DigitalEditingSurvey, {
    uuid: uuid,
    digitalEditingSurveyUrl: digitalEditingSurveyUrl
  })) : null);
};
export default DigitalEditingSidebar;